var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "view_cont" }, [
      _c("dl", { staticClass: "view_subject" }, [
        _c("dt", { staticClass: "subject voc_title" }, [
          _vm._v(
            "\n                " +
              _vm._s(_vm.$t("FIELD.VOC.INFORMATION")) +
              "\n            "
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "view_question" }, [
        _c("dl", { staticClass: "dl_view" }, [
          _c("dt", [_vm._v(_vm._s(_vm.$t("FIELD.VOC.NO")))]),
          _vm._v(" "),
          _c("dd", [_vm._v(_vm._s(_vm.data.VOC_SEQ))]),
          _vm._v(" "),
          _c("dt", [_vm._v(_vm._s(_vm.$t("FIELD.BP.NUMBER")))]),
          _vm._v(" "),
          _c("dd", [
            _c(
              "a",
              {
                staticClass: "link_attch",
                attrs: { href: "javascript:" },
                on: { click: _vm.RequestVocUserInfoPopup }
              },
              [_vm._v(_vm._s(_vm.data.BP_NO))]
            )
          ]),
          _vm._v(" "),
          _c("dt", [_vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.REQUEST.DATE")))]),
          _vm._v(" "),
          _c("dd", [_vm._v(_vm._s(_vm.data.VOC_DT))])
        ]),
        _vm._v(" "),
        _c("dl", { staticClass: "dl_view" }, [
          _c("dt", [_vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.INQUIRY.TYPE")))]),
          _vm._v(" "),
          _c("dd", [_vm._v(_vm._s(_vm.data.INQUIRY_TYPE_NM))]),
          _vm._v(" "),
          _c("dt", [_vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.CATEGORY")))]),
          _vm._v(" "),
          _c("dd", [
            _vm._v(
              _vm._s(_vm.data.CATE_MAIN_NM) +
                " / " +
                _vm._s(_vm.data.CATE_SUB_NM)
            )
          ]),
          _vm._v(" "),
          _c("dt", [_vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.MODEL.CODE")))]),
          _vm._v(" "),
          _c("dd", [_vm._v(_vm._s(_vm.data.SELECT_MODEL_CODE))])
        ]),
        _vm._v(" "),
        _c("dl", { staticClass: "dl_write" }, [
          _c("dt", [_vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.QNA.DESC")))]),
          _vm._v(" "),
          _c("dd", { attrs: { "data-input-type": "textarea" } }, [
            _c("textarea", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.queDesc,
                  expression: "queDesc"
                }
              ],
              staticClass: "textarea_ty w100p",
              attrs: { readonly: "" },
              domProps: { value: _vm.queDesc },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.queDesc = $event.target.value
                }
              }
            })
          ])
        ])
      ]),
      _vm._v(" "),
      "01" != _vm.status
        ? _c("section", { staticClass: "answer_question_wrap voc_question" }, [
            _c("p", { staticClass: "sec_title" }, [
              _c("em", [_vm._v(_vm._s(_vm.$t("FIELD.VOC.ANSWER.LINE")))])
            ]),
            _vm._v(" "),
            _c("dl", { staticClass: "dl_write" }, [
              _c("dt", [
                _vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.ANS.DESC"))),
                "02" === _vm.status
                  ? _c("em", { staticClass: "txt_mandatory" }, [_vm._v("*")])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("dd", { attrs: { "data-input-type": "textarea" } }, [
                _c("textarea", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.ansDesc,
                      expression: "ansDesc"
                    }
                  ],
                  staticClass: "textarea_ty w100p",
                  attrs: { readonly: "03" === _vm.status ? true : false },
                  domProps: { value: _vm.ansDesc },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.ansDesc = $event.target.value
                    }
                  }
                })
              ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "btn_wrap_full topLine" }, [
        _c(
          "a",
          {
            staticClass: "btn_white",
            attrs: { href: "javascript:" },
            on: { click: _vm.goListBack }
          },
          [
            _vm._v(
              "\n                " +
                _vm._s(_vm.$t("BUTTON.GLOBAL.LIST")) +
                "\n            "
            )
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "btn_right pc_only" }, [
          _vm.btnShow("01")
            ? _c(
                "a",
                {
                  staticClass: "btn_blue",
                  attrs: { href: "javascript:" },
                  on: {
                    click: function($event) {
                      return _vm.save("02")
                    }
                  }
                },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$t("BUTTON.GLOBAL.ACCEPT")) +
                      "\n                "
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.btnShow("02")
            ? _c(
                "a",
                {
                  staticClass: "btn_blue",
                  attrs: { href: "javascript:" },
                  on: {
                    click: function($event) {
                      return _vm.save("03")
                    }
                  }
                },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$t("FIELD.FAST.ANSWER")) +
                      "/" +
                      _vm._s(_vm.$t("BUTTON.GLOBAL.COMPLETE")) +
                      "\n                "
                  )
                ]
              )
            : _vm._e()
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4f4a2f22", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f4a2f22","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/skpComponents/view/basis/eur/voc/RequestVocDetail.vue
// module id = zmxM
// module chunks = 0